/* eslint-disable max-len */
import React from 'react';

const ByDefault: React.FC<object> = () => {

    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.77 0.853381C6.52797 0.116581 5.47674 0.116581 5.23551 0.853381L4.37226 3.48698C4.31952 3.64737 4.21699 3.78712 4.07934 3.88626C3.94168 3.9854 3.77595 4.03886 3.60582 4.03898H0.812749C0.0309801 4.03898 -0.293345 5.03098 0.338363 5.48698L2.59734 7.11418C2.73528 7.21341 2.83799 7.35339 2.89074 7.51406C2.9435 7.67474 2.94359 7.84785 2.89101 8.00858L2.02776 10.6422C1.78572 11.379 2.63688 11.9926 3.2702 11.5366L5.52918 9.90938C5.66697 9.81018 5.83288 9.75676 6.00316 9.75676C6.17344 9.75676 6.33935 9.81018 6.47714 9.90938L8.73612 11.5366C9.36864 11.9926 10.219 11.379 9.97775 10.6422L9.1145 8.00858C9.06192 7.84785 9.06201 7.67474 9.11477 7.51406C9.16753 7.35339 9.27023 7.21341 9.40817 7.11418L11.6663 5.48778C12.298 5.03178 11.9729 4.03978 11.192 4.03978H8.3997C8.22943 4.03983 8.06351 3.98645 7.92569 3.8873C7.78788 3.78815 7.68523 3.6483 7.63245 3.48778L6.7692 0.854181L6.77 0.853381Z"
                fill="#616E6E"
            />
        </svg>
    );
};

export default ByDefault;